/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Mapnomarkers2Inputs */

const zh_print_mapnomarkers2 = /** @type {(inputs: Print_Mapnomarkers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无地图标记`)
};

const en_print_mapnomarkers2 = /** @type {(inputs: Print_Mapnomarkers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No map markers`)
};

const es_print_mapnomarkers2 = /** @type {(inputs: Print_Mapnomarkers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin marcadores`)
};

/**
* | output |
* | --- |
* | "No map markers" |
*
* @param {Print_Mapnomarkers2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_mapnomarkers2 = /** @type {((inputs?: Print_Mapnomarkers2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Mapnomarkers2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_mapnomarkers2(inputs)
	if (locale === "en") return en_print_mapnomarkers2(inputs)
	return es_print_mapnomarkers2(inputs)
});
export { print_mapnomarkers2 as "print_mapNoMarkers" }